import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleError, hasError } from '@repo/shared/api/helpers'

import { AsyncThunkConfig, RejectValue } from '../actions'

export const checkAuth = createAsyncThunk<{ userId: string }, void, AsyncThunkConfig>(
  'CHECK_AUTH',
  async (_, { extra, rejectWithValue, fulfillWithValue }) => {
    const { api, altApi, accessTokenManager } = extra
    const accessToken = accessTokenManager.get()
    if (!accessToken) return rejectWithValue(RejectValue.NoAccess)
    api.auth.updateAccessToken({ accessToken })
    altApi.setAccessToken(accessToken)
    const res = await api.auth.verify({ accessToken })
    if (hasError(res)) return rejectWithValue(handleError(res))
    return fulfillWithValue(res)
  },
)
